import TrainingService from './service';

const store = {
    namespaced: true,

    state: {
        trainings: [],
        activeTrainingId: null,
        trainingData: {
            id: null,
            name: "",
            resources: [],
            states: [],
            timelines: [],
            chapters: [],
            directories: []
        }
    },

    mutations: {
        SET_TRAININGS: function (state, trainings) {
            state.trainings = trainings;
        },

        SET_ACTIVE_TRAINING: function (state, { id, name, resources, states, timelines, chapters, directories, loadingStateWithStepMenu }) {
            state.activeTrainingId = id;
            state.trainingData = {
                id,
                name,
                resources,
                states,
                timelines,
                chapters,
                directories,
                loadingStateWithStepMenu
            };
        }
    },

    actions: {
        loadAvailableTrainings: async function ({ commit }) {
            if (window.noserver) {
                return;
            }

            try {
                const data = await TrainingService.fetchTrainingData();
                commit('SET_TRAININGS', data);
            } catch (error) {
                console.log('Failed to load available training:', error.message);
            }
        },

        setActiveTraining: function ({commit, state}, trainingId) {
            try {
                const training = state.trainings.find(training => training._id === trainingId);
                const {name, resources, states, timelines, chapters, directories} = training;
                commit('SET_ACTIVE_TRAINING', {
                    id: trainingId,
                    name,
                    resources,
                    states,
                    timelines,
                    chapters,
                    directories,
                    loadingStateWithStepMenu: false
                });
                TrainingTreeController.trainingTreeView.setData(TrainingTreeController.getTreeState());
            } catch (error) {
                console.log('Failed to set active training:', error.message);
            }
        },

        setCustomActiveTraining: function ({commit, state}, training) {
            try {
                const { name, resources, states, timelines, chapters, directories, loadingStateWithStepMenu } = training;
                commit('SET_ACTIVE_TRAINING', {
                    id: training.id || training._id,
                    name,
                    resources,
                    states,
                    timelines,
                    chapters,
                    directories,
                    loadingStateWithStepMenu
                });
                commit('SET_TRAININGS', [training]);
            } catch (error) {
                console.log('Failed to set active training:', error.message);
            }
        },

        closeTraining: async function ({commit}) {
            commit('SET_ACTIVE_TRAINING', {
                id: null,
                name: "",
                resources: [],
                states: [],
                timelines: [],
                chapters: [],
                directories: []
            });
        }
    }
};

export default function register(rootStore) {
    rootStore.registerModule('training', store);
}
